module.exports = __webpack_public_path__ + "media/icons/maintenance-c9374944.svg";